module.exports = __webpack_public_path__ + "img/patient-icon.9b8cf7aa.svg";